import * as React from "react";
import { styled } from "@mui/material";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const base = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 100,
	height: 100,
	fill: "none",
	viewBox: "0 0 100 100",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#C42E21",
			d: "M83.14 69.34c6.46 2 20.46 16.4 25.43 23.79l3.75 4.97-5.82 6.19c-4.28-5.64-14.55-18.8-20.17-23.43-5.61-4.64-10.33-4.14-13.3.43-2.96 4.57 1.65 8.4 1.65 8.4l-2.77 4.9c-1.25-.63-5.58-2.4-6.92-8.3-1.55-6.79 4.96-21.02 18.15-16.95Z"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_11891_29244",
			width: 49,
			height: 37,
			x: 64,
			y: 68,
			maskUnits: "userSpaceOnUse",
			style: { maskType: "alpha" },
			children: /* @__PURE__ */ _jsx("path", {
				fill: "#C42E21",
				d: "M83.14 69.35c6.47 2 20.46 16.4 25.43 23.79l3.76 4.97-5.83 6.19c-4.28-5.64-14.55-18.8-20.16-23.44-5.62-4.63-10.34-4.13-13.3.44-2.97 4.56 1.64 8.39 1.64 8.39l-2.77 4.9c-1.24-.62-5.57-2.39-6.92-8.29-1.55-6.79 4.96-21.02 18.15-16.95Z"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_11891_29244)",
			children: /* @__PURE__ */ _jsx("path", {
				fill: "#fff",
				fillRule: "evenodd",
				d: "m67.05 68.98 8.3 16.79 6.16-3.05-8.3-16.79-6.16 3.05Zm15.6 12.77 9.7-9.42 4.25 4.37-9.7 9.42-4.24-4.37ZM94.22 94.3l9.7-9.42 3.1 3.19-9.7 9.42-3.1-3.19Zm-33.44 4.15L60.6 88.1l15.26-.23.16 10.35-15.26.23Z",
				clipRule: "evenodd"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#C42E21",
			d: "M38.68 28.9c-5.76-3.56-15.69-21-18.64-29.41l-2.39-5.76 7.2-4.53c2.72 6.53 9.36 21.86 13.63 27.75 4.27 5.9 8.97 6.6 12.98 2.92 4.02-3.68.51-8.54.51-8.54l3.92-4.05c1.04.92 4.8 3.72 4.61 9.77-.2 6.96-10.08 19.1-21.82 11.85Z"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask1_11891_29244",
			width: 44,
			height: 43,
			x: 17,
			y: -11,
			maskUnits: "userSpaceOnUse",
			style: { maskType: "alpha" },
			children: /* @__PURE__ */ _jsx("path", {
				fill: "#C42E21",
				d: "M38.68 28.89c-5.76-3.56-15.7-21-18.64-29.41l-2.39-5.76 7.19-4.53c2.73 6.53 9.36 21.86 13.63 27.75 4.28 5.9 8.97 6.6 12.99 2.92 4.01-3.68.51-8.54.51-8.54l3.92-4.05c1.04.92 4.8 3.72 4.61 9.77-.2 6.96-10.08 19.1-21.82 11.85Z"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask1_11891_29244)",
			children: /* @__PURE__ */ _jsx("path", {
				fill: "#fff",
				fillRule: "evenodd",
				d: "m54.16 33.29-3.82-18.33-6.73 1.4 3.82 18.33 6.73-1.4ZM42.26 17 30.5 23.69l-3-5.3 11.75-6.68 3 5.3ZM34.23 1.96 22.47 8.64l-2.2-3.87L32.03-1.9l2.2 3.87Zm33.4 4.38L65.2 16.4l-14.83-3.6 2.45-10.07 14.83 3.61Z",
				clipRule: "evenodd"
			})
		})
	]
});
const SvgTileBgCanes = styled(base)({});
export default SvgTileBgCanes;
